import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=c50dc1fe&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c50dc1fe')) {
      api.createRecord('c50dc1fe', component.options)
    } else {
      api.reload('c50dc1fe', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=c50dc1fe&", function () {
      api.rerender('c50dc1fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-203o1cdn0pv03/JS/videoIframe.vue"
export default component.exports